import { useNavigate } from 'react-router-dom'
import Box from 'ui/src/components/Box'
import LogoCircle from 'ui/src/assets/images/ProtexxaLogos/ProtexxaLogo-circle.svg?react'

const Header = () => {
  const navigate = useNavigate()

  return (
    <Box
      sx={{
        pl: { xs: 2, md: 12 },
        py: 3,
      }}
    >
      <LogoCircle onClick={() => navigate('/company/dashboard')} />
    </Box>
  )
}

export default Header
